'use client'; // Error boundaries must be Client Components

import { ArrowLeft, RefreshCwIcon } from 'lucide-react';
import Link from 'next/link';
import { Button } from '~/components/ui/button';
import { useErrorLogger } from '~/hooks/errors/use-error-logger';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useErrorLogger({
    error,
    boundaryLocation: 'StandardLayoutErrorBoundary',
  });

  return (
    <div className="flex min-h-[8-vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-9xl font-extrabold text-primary">500</h1>
      <h2 className="mt-4 text-2xl font-semibold">Server Error</h2>
      <p className="mt-2 max-w-md">
        An error occurred while trying to display this page.
      </p>
      <div className="mt-8 flex gap-6">
        <Button asChild variant="outline">
          <Link href="/">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Link>
        </Button>
        <Button
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => reset()
          }
        >
          <RefreshCwIcon className="mr-2 h-4 w-4" /> Retry
        </Button>
      </div>
    </div>
  );
}
